import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VolunteerActivismIcon(props: IconProps) {
    return <Icon {...props} iconKey={"volunteer_activism"}/>
}
